export default `:host {
  display: inline-block;
  margin-bottom: 16px;
}

/* Ids Checkbox Group */
.ids-checkbox-group ids-text:not(:empty) {
  display: block;
  margin-block-end: var(--ids-space-12);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtY2hlY2tib3giLCJzb3VyY2VzIjpbImlkcy1jaGVja2JveC1ncm91cC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTs7O0FBR0Y7QUFFRTtFQUNFO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdHtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICBtYXJnaW4tYm90dG9tOiAxNnB4O1xufVxuIFxuLyogSWRzIENoZWNrYm94IEdyb3VwICovXG4uaWRzLWNoZWNrYm94LWdyb3VwIHtcbiAgaWRzLXRleHQ6bm90KDplbXB0eSkge1xuICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgIG1hcmdpbi1ibG9jay1lbmQ6IHZhcigtLWlkcy1zcGFjZS0xMik7XG4gIH1cbn1cbiJdfQ== */`;
